var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: { "label-position": "top", "label-width": "180px" },
              model: {
                value: _vm.pram,
                callback: function ($$v) {
                  _vm.pram = $$v
                },
                expression: "pram",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                _vm._l(_vm.tableData.data, function (item, index) {
                  return _c(
                    "el-col",
                    {
                      key: index,
                      attrs: { span: item.key == "web_announcement" ? 24 : 6 },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.setName(item.key),
                            prop: "remark",
                          },
                        },
                        [
                          _vm.inputList.includes(item.key)
                            ? _c("el-input", {
                                attrs: {
                                  placeholder: _vm.setPLaceHolder(item.key),
                                },
                                model: {
                                  value: item.value,
                                  callback: function ($$v) {
                                    _vm.$set(item, "value", $$v)
                                  },
                                  expression: "item.value",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.nowKey.includes(item.key)
                            ? _c("el-input", {
                                attrs: {
                                  placeholder: _vm.setPLaceHolder(item.key),
                                },
                                model: {
                                  value: item.link,
                                  callback: function ($$v) {
                                    _vm.$set(item, "link", $$v)
                                  },
                                  expression: "item.link",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voInput.includes(item.key)
                            ? _c(
                                "el-input",
                                {
                                  model: {
                                    value: item.value,
                                    callback: function ($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v(_vm._s(_vm.$t("miao"))),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.orList.includes(item.key)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: _vm.$t("qxz") },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("kaiqi"),
                                          value: "1",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("guanbi"),
                                          value: "0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.bankList.includes(item.key)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: _vm.$t("qxz") },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("usdt"),
                                          value: _vm.$t("usdt"),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("rmb"),
                                          value: _vm.$t("rmb"),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("usdtArmb"),
                                          value: _vm.$t("usdtArmb"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.xianLit.includes(item.key)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1" } },
                                        [_vm._v(_vm._s(_vm.$t("xsan")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "0" } },
                                        [_vm._v(_vm._s(_vm.$t("ycan")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.lanList.includes(item.key)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        "collapse-tags": "",
                                        placeholder: _vm.$t("qxz"),
                                      },
                                      model: {
                                        value: item.lanList,
                                        callback: function ($$v) {
                                          _vm.$set(item, "lanList", $$v)
                                        },
                                        expression: "item.lanList",
                                      },
                                    },
                                    _vm._l(
                                      _vm.languarList,
                                      function (tag, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: tag.value,
                                            value: tag.lang,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.moneyTypeList.includes(item.key)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: _vm.$t("qxz") },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("usdt"),
                                          value: _vm.$t("usdt"),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("rmb"),
                                          value: _vm.$t("rmb"),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("usdtArmb"),
                                          value: _vm.$t("usdtArmb"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer flex-end" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["roleManager:configuration:save"],
                      expression: "['roleManager:configuration:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("trueText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }